
import Vue from 'vue'
import VueRouter from 'vue-router'
import SiteMembers from '@/components/System/SiteMembers';
import SiteMemberSingle from '@/components/System/SiteMemberSingle';
import SystemTrainingDocument from '@/components/System/SystemTrainingDocument';
import Home from '../pages/Home.vue'
import Roadmap from '../components/Roadmap'
import SystemTicketsLogging from '../components/SystemTicketsLogging'
import SystemTickets from '../views/SystemTickets'
import Login from '../views/login'
import SignUp from '../views/signup'
import PermissionError from '@/views/PermissionError'
import BusinessUnits from '@/views/BusinessUnits'
import Users from '@/views/Users'
import MyProfile from '../views/MyProfile'
import DataImports from '@/views/DataImports'
import DataImport from '@/views/DataImport/Single'
import Activities from '@/views/Activities';
import Activity from '@/views/Activity/Single';
import MyActivities from '@/views/MyActivities'
import MySchedule from '@/components/MySchedule'
import MyTeamSchedule from '@/components/MyTeamSchedule'
import MyActivitiesbyType from '@/views/Activities/MyActivitiesbyType';
import MyTeamActivities from '@/views/MyTeamActivities'
import MyTeamMemberActivities from '@/views/MyTeamMemberActivities'
import TeamMemberActivities from '@/views/TeamActivities/TeamMemberActivities'
import User from '@/views/User/Single';
import DebtCounselling from '@/pages/DebtCounselling';
import ContactUs from '@/pages/ContactUs';
import Welcome from '@/pages/Welcome';
import Rehabilitation from '@/pages/Rehabilitation';
import Services from '@/pages/Services';
import Liquidation from '@/pages/Liquidation';
import VoluntarySequestration from '@/pages/VoluntarySequestration';

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/SiteMembers',
    name: 'SiteMembers',
    component: SiteMembers
  },
   {
    path: '/SiteMember/:id',
    name: 'SiteMemberSingle',
    component: SiteMemberSingle
  },
  {
    path: '/SystemTraining/:id',
    name: 'SystemTrainingDocument',
    component: SystemTrainingDocument
  },
  {
    path: '/Roadmap',
    name: 'Roadmap',
    component: Roadmap
  },
  {
    path: '/SystemTickets/Logging',
    name: 'SystemTicketsLogging',
    component: SystemTicketsLogging
  },  
  {
    path: '/SystemTickets',
    name: 'SystemTickets',
    component: SystemTickets
  }, 
  {
    path: '/PermissionError',
    name: 'PermissionError',
    component: PermissionError
  },
  {
    path: '/BusinessUnits',
    name: 'BusinessUnits',
    component: BusinessUnits
  },
  {
    path: '/Users',
    name: 'Users',
    component: Users
  },
  {
    path: '/DataImports',
    name: 'DataImports',
    component: DataImports,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/Activities',
    name: 'activities',
    component: Activities
  },
  {
    path: '/MyActivities/:id',
    name: 'MyActivitiesbyType',
    component: MyActivitiesbyType,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/MyTeamSchedule',
    name: 'MyTeamSchedule',
    component: MyTeamSchedule,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/MySchedule',
    name: 'MySchedule',
    component: MySchedule,
    meta: {
      requiresAuth: true
    }
  },
  
  {
    path: '/MyTeamActivities',
    name: 'MyTeamActivities',
    component: MyTeamActivities,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/MyTeamActivities/:id',
    name: 'MyTeamMemberActivities',
    component: MyTeamMemberActivities,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/TeamMemberActivities/:id/:prop',
    name: 'TeamMemberActivities',
    component: TeamMemberActivities,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/Activity/:id',
    name: 'activity',
    component: Activity
  },
  {
    path: '/MyActivities',
    name: 'MyActivities',
    component: MyActivities,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/DataImport/:id',
    name: 'DataImport',
    component: DataImport,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/Login',
    name: 'login',
    component: Login
  },
  {
    path: '/SignUp',
    name: 'signup',
    component: SignUp
  },
  {
    path: '/MyProfile',
    name: 'myprofile',
    component: MyProfile,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/User/:id',
    name: 'user',
    component: User,
    meta: {
        requiresAuth: true
      }
  },
  {
    path: '/DebtCounselling',
    name: 'debtcounselling',
    component: DebtCounselling
  },
  {
    path: '/ContactUs',
    name: 'contactus',
    component: ContactUs
  },
  {
    path: '/Welcome',
    name: 'welcome',
    component: Welcome
  },
  {
    path: '/Rehabilitation',
    name: 'rehabilitation',
    component: Rehabilitation
  },
  {
    path: '/Services',
    name: 'services',
    component: Services
  },
  {
    path: '/Liquidation',
    name: 'liquidation',
    component: Liquidation
  },
  {
    path: '/VoluntarySequestration',
    name: 'voluntarysequestration',
    component: VoluntarySequestration
  },
  
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
// router.beforeEach((to, from, next) => {
//   window.scrollTo(0, 0)
//   // ...
// })
export default router
    